<template>
    <section>
        <v-input 
            :htmlId="'CorrespondanceAddressStreet'" 
            :label="'Ulica'" 
            :value="correspondanceAddressStreet" />
        <v-input 
            :htmlId="'CorrespondanceAddressBuildingNo'" 
            :label="'Numer domu'" 
            :value="correspondanceAddressBuildingNumber"/>
        <v-input 
            :htmlId="'CorrespondanceAddressFlatNo'" 
            :label="'Numer lokalu'" 
            :value="correspondanceAddressFlatNumber" />
        <v-input 
            :htmlId="'CorrespondanceAddressPostalCode'" 
            :label="'Kod pocztowy'" 
            :value="correspondanceAddressPostalCode" />
        <v-input 
            :htmlId="'CorrespondanceAddressCity'" 
            :label="'Miejscowość'" 
            :value="correspondanceAddressCity" />
        <!-- <v-select 
            :htmlId="'CorrespondanceAddressProvinceId'" 
            :label="'Województwo'" 
            :list="provinces"
            :disable="disableProvince"
            :value="setProvinceValue" /> -->
        <v-select 
            :htmlId="'CorrespondanceAddressCountryId'" 
            :label="'Kraj'" 
            :searchable="true"
            :list="countries"
            @change="setCountryName($event, 'setCorrespondanceAddressCountry')"
            :value="correspondanceAddressCountryId.toString()" />
    </section>
</template>


<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item'

export default {
    data() {
        return {
            plId: 160
        }
    },
    props: {
        provinces: {
            type: Array,
            required: true
        },
        countries: {
            type: Array,
            required: true
        }
    },
    mixins: [
        getDictionaryItem
    ],
    methods: {
        setCountryName(e, mutationName) {
            let countryName = this.getDictionaryItem(this.countries, 'text', 'value', parseInt(e))
            this.$store.commit(mutationName, countryName)
        }
    },
    computed: {
        correspondanceAddressStreet() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.street ? this.$store.getters.getMyFx.correspondAddress.street : ''},
        correspondanceAddressBuildingNumber() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.buildingNumber ? this.$store.getters.getMyFx.correspondAddress.buildingNumber : ''},
        correspondanceAddressFlatNumber() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.flatNumber ? this.$store.getters.getMyFx.correspondAddress.flatNumber : ''},
        correspondanceAddressPostalCode() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.postalCode ? this.$store.getters.getMyFx.correspondAddress.postalCode : ''},
        correspondanceAddressCity() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.city ? this.$store.getters.getMyFx.correspondAddress.city : ''},
        correspondanceAddressProvinceId() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.provinceId ? this.$store.getters.getMyFx.correspondAddress.provinceId : ''},
        correspondanceAddressCountryId() { return this.$store.getters.getMyFx && this.$store.getters.getMyFx.correspondAddress.countryId ? this.$store.getters.getMyFx.correspondAddress.countryId : 160},
        // disableProvince() { return this.correspondanceAddressCountryId !== this.plId },
        // setProvinceValue() { return this.correspondanceAddressCountryId !== this.plId ? '' : this.correspondanceAddressProvinceId.toString() }
    }
}
</script>
